export class SetMaintenanceWorkStatus {
  public static readonly type = '[Maintenance Work] set status';
  constructor(public payload: { maintenanceActive: boolean; statusMessage: string }) {}
}
